import { BsLinkedin, BsGithub, BsWhatsapp } from "react-icons/bs";
import { FiMail } from "react-icons/fi";

const Icons = () =>{
    return(
        <>
                <div className="user_links">
                    <a href="https://www.linkedin.com/in/aman-verma-818a26203" className="link_btn social"><BsLinkedin/></a>
                    <a href="mailto:amanvermabitd@gmail.com" className="link_btn social"><FiMail/></a>
                    <a href="https://github.com/Amanverma1101" className="link_btn social"><BsGithub/></a>
                    <a href="https://wa.me/+917070870833" className="link_btn social"><BsWhatsapp/></a>
                </div>
        </>
    )
}
export default Icons